import { render, staticRenderFns } from "./FirstSection.vue?vue&type=template&id=12f9ae66&scoped=true&"
import script from "./FirstSection.vue?vue&type=script&lang=js&"
export * from "./FirstSection.vue?vue&type=script&lang=js&"
import style0 from "./FirstSection.vue?vue&type=style&index=0&id=12f9ae66&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12f9ae66",
  null
  
)

export default component.exports